const bikeData = {
  "GAS GAS": {
    "MC 250": ["2022", "2023", "2024"],
    "EC 300": ["2021", "2022", "2024"],
    "EX 300": ["2021", "2022", "2024"],
    "EC 250": ["2021", "2022", "2024"],
    "EX 250": ["2022", "2024"]
  },
  "HUSQVARNA": {
    "TE 250": ["2023"],
    "TE 300": ["2023", "2024"],
    "TE 250i": ["2020", "2021", "2022"],
    "TE 300i": ["2020", "2021", "2022"],
    "TX 300i": ["2020", "2021", "2022"],
    "TC 250": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "TX 300": ["2019", "2023", "2024"]
  },
  "KTM": {
    "SX 250": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "XC 250": ["2019", "2023", "2024"],
    "XC 300": ["2019", "2023", "2024"],
    "SX 300": ["2023", "2024"],
    "XC-W 250": ["2023", "2024"],
    "XC-W 300": ["2023", "2024"],
    "XC-TPI 250": ["2020", "2021", "2022"],
    "XC-TPI 300": ["2020", "2021", "2022"],
    "EXC-TPI 300": ["2020", "2021"]
  }
};
